import { ConvertPriceToString } from "../../../Helpers/CustomConverter";

const BalanceItem = ({ item }) => {

    const getRangeString = () => {
        var range;
        debugger
        if (item.dayFrom < 0) {
            range = 'Przyszłe'
        } else if (item.dayUntil.toString().length > 4) {
            range = 'Ponad ' + (parseInt(item.dayFrom) - 1).toString() + ' dni';
        } else {
            range = item.dayFrom + '-' + item.dayUntil + ' dni';
        }
        return range;
    }
    return (
        <tr className="hoverable-row">
            <td style={{ alignContent: "center", verticalAlign: 'middle' }}>{getRangeString()}</td>
            <td style={{ alignContent: "center", verticalAlign: 'middle', textAlign: 'right' }}>{ConvertPriceToString(item.saleAmount)}</td>
            <td style={{ alignContent: "center", verticalAlign: 'middle', textAlign: 'right' }}>{item.saleNumber}</td>
            <td style={{ alignContent: "center", verticalAlign: 'middle', textAlign: 'right' }}>{ConvertPriceToString(item.purchAmount)}</td>
            <td style={{ alignContent: "center", verticalAlign: 'middle', textAlign: 'right' }}>{item.purchNumber}</td>
        </tr>
    );
};

export default BalanceItem;
